import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { Offcanvas, OffcanvasHeader, OffcanvasBody } from "reactstrap";
import SimpleBar from "simplebar-react";
import { fetchVendorWiseProduct } from "../../api/requisition";
import { useNavigate } from "react-router-dom";

const ProductRightSideBar = (props) => {
  const navigate = useNavigate();
  const [productList, setProductList] = useState([]);
  const toggleLeftCanvas = () => {
    props.setOpen(false);
  };

  window.onscroll = function () {
    scrollFunction();
  };

  const goToGeneratePo = (params) => {
    navigate("/purchase-manager/management-approve-po-generate", {
      state: params,
    });
  };

  const scrollFunction = () => {
    const element = document.getElementById("back-to-top");
    if (element) {
      if (
        document.body.scrollTop > 100 ||
        document.documentElement.scrollTop > 100
      ) {
        element.style.display = "block";
      } else {
        element.style.display = "none";
      }
    }
  };

  const toTop = () => {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  };

  const getProductList = async () => {
    try {
      const vendorIdWithDate = props.rowValue.id;
      const response = await fetchVendorWiseProduct(vendorIdWithDate);
      setProductList(response.data.managementApprovedProductList);
      props.setSidebarLoad(false);
    } catch (error) {
      console.log("error in fetching products--", error);
      toast.error("Error in fetching products");
    }
  };

  useEffect(() => {
    getProductList();
  }, []);

  return (
    <React.Fragment>
      <button
        onClick={() => toTop()}
        className="btn btn-danger btn-icon"
        id="back-to-top"
      >
        <i className="ri-arrow-up-line"></i>
      </button>

      <div>
        <div className="customizer-setting d-none d-md-block">
          <div
            onClick={toggleLeftCanvas}
            className="btn-info btn-rounded shadow-lg btn btn-icon btn-lg p-2"
          >
            <i className="mdi mdi-spin mdi-cog-outline fs-22"></i>
          </div>
        </div>
        <Offcanvas
          isOpen={props.open}
          toggle={toggleLeftCanvas}
          direction="end"
          className="offcanvas-end border-0"
        >
          <OffcanvasHeader
            className="d-flex align-items-center bg-primary bg-gradient p-3 offcanvas-header-dark"
            toggle={toggleLeftCanvas}
          >
            <span className="m-0 me-2 text-white">Product List</span>
          </OffcanvasHeader>
          <OffcanvasBody className="p-0">
            <SimpleBar className="h-100">
              <div className="p-3 pt-3">
                <div className="d-flex align-items-center justify-content-between mb-2">
                  <h6 className="mb-0 fw-semibold text-uppercase">
                    {props.rowValue.vendor_name}
                  </h6>
                </div>
                <p className="text-muted">{}</p>

                {props.sidebarLoad ? (
                  <div className="text-center">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                ) : (
                  <table style={{ borderCollapse: "collapse", width: "100%" }}>
                    <thead>
                      <tr
                        style={{
                          borderBottom: "1px solid #E8E8E8",
                          borderTop: "1px solid #E8E8E8",
                        }}
                      >
                        <th
                          style={{
                            borderRight: "1px solid #E8E8E8",
                            borderLeft: "1px solid #E8E8E8",
                            padding: "5px",
                            color: "rgb(84, 91, 105)",
                          }}
                        >
                          <p className="mb-0">Product Name</p>
                        </th>
                        <th
                          style={{
                            borderRight: "1px solid #E8E8E8",
                            padding: "5px",
                            color: "rgb(84, 91, 105)",
                          }}
                        >
                          <p className="mb-0">Product Code</p>
                        </th>
                        <th
                          style={{
                            borderRight: "1px solid #E8E8E8",
                            padding: "5px",
                            color: "rgb(84, 91, 105)",
                          }}
                        >
                          <p className="mb-0">Approved Quantity</p>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {productList.map((product, index) => (
                        <tr key={index} style={{ border: "1px solid #E8E8E8" }}>
                          <td
                            style={{
                              borderRight: "1px solid #E8E8E8",
                              padding: "5px",
                            }}
                          >
                            {product.item_name}
                          </td>
                          <td
                            style={{
                              borderRight: "1px solid #E8E8E8",
                              padding: "5px",
                            }}
                          >
                            {product.item_no}
                          </td>
                          <td
                            style={{
                              borderRight: "1px solid #E8E8E8",
                              padding: "5px",
                            }}
                          >
                            {product.approve_quantity}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
                <br />
                <div className="d-flex justify-content-center mt-4">
                  <button
                    className="btn btn-primary"
                    onClick={() => goToGeneratePo(props.rowValue)}
                  >
                    PO Generate
                  </button>
                </div>
              </div>
            </SimpleBar>
          </OffcanvasBody>
        </Offcanvas>
      </div>
    </React.Fragment>
  );
};

export default ProductRightSideBar;
